import { render, staticRenderFns } from "./DatatableListAdm.vue?vue&type=template&id=3f767ea9&"
import script from "./DatatableListAdm.vue?vue&type=script&lang=js&"
export * from "./DatatableListAdm.vue?vue&type=script&lang=js&"
import style0 from "./DatatableListAdm.vue?vue&type=style&index=0&id=3f767ea9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports